// Copy for the honest-build homepage. Numbers never live here — they come
// from GET /public/stats and GET /api/v1/public/match-nights.

export const HEADLINE = "CS2 matchmaking you can actually trust.";

export const TEAM_NOTE =
  "We built Ouro because CS deserves better than cheaters, alt accounts, and people who ruin the game for everyone else. We wanted to solo queue and actually trust the other nine people in the lobby. The player base is still small, and we'd rather say that than fake it.";

export const TEAM_SIGNATURE = "The Ouro team";

export const HERO_SUBHEAD =
  "Import your FACEIT ELO. Multi-signal matching. No seasons, no reset, no decay. Free to join. Steam sign-in is read-only.";

export const HERO_PILLARS = [
  {
    title: "Human review",
    body: "We do not just import FACEIT ELO. We check recent performance, and may bump your starting Ouro rating to the one you actually deserve.",
  },
  {
    title: "Multi-signal matchmaking",
    body: "Skill, recent form, and reputation. Teams are drafted even. Not ELO alone.",
  },
  {
    title: "No seasons",
    body: "Your ELO does not reset and does not decay. No seasonal wipe.",
  },
  {
    title: "Free and read-only",
    body: "No card. A Steam account is all you need to join. Steam OpenID cannot touch your inventory.",
  },
];

export const HERO_BUILDOUT =
  "We're in a buildout phase toward 24/7 matchmaking. Until the community can fill games on demand, you book a match night here and play it on Discord.";

export const STAT_LABELS = {
  signupsTotal: "Total signups",
  rejectedTotal: "Turned away in review",
  eligibleTotal: "Eligible to play",
  matchesTotal: "Matches played",
  discordMembers: "Discord members",
};

export const STATS_FOOTNOTE =
  "Live counts, refreshed regularly. Not projections.";

export const DISCORD_CTA_LABEL = "Join the Discord";
export const STEAM_CTA_LABEL = "Sign in with Steam";
export const STEAM_PERMISSION_LINE =
  "Steam OpenID gives us your public profile and match stats. We cannot see your inventory, trade, or post as you. A Steam account is all you need to join.";

// TODO: Confirm this is the live invite used in Discord. The page still
// fetches the current URL from the public settings endpoint at runtime.
export const DISCORD_INVITE_CONFIRMATION_TODO = true;

// TODO: Recurring cadence in CEST, e.g. "every Thursday at 20:00 CEST".
// The next night's date, time, and roster come from the database — this
// string is only the editorial "when we usually play" sentence.
export const MATCH_NIGHT_CADENCE = "";

export const HOW_THIS_WORKS = {
  eyebrow: "Right now",
  title: "How this works now",
  titleAccent: "now",
  intro:
    "24/7 matchmaking is the goal. We are in a buildout phase, so an always-on queue would sit empty. Match nights are how you play right now: book a spot here, then show up on Discord.",
  points: [
    {
      title: "Buildout, not 24/7 yet",
      body: "Always-on matchmaking needs a bigger community. Until then, scheduled nights are how games actually fill.",
    },
    {
      title: "Book here, play on Discord",
      body: "You reserve a spot on this site. Discord is where we ping, fill last-minute seats, and move people into a match.",
    },
    {
      title: "Discord is how you find games",
      body: "Pings, last-minute fills, and the people who already played a night live there. You do not need a Steam login to look around.",
    },
    {
      title: "What we ask of you",
      body: "If you reserve a night, show up. Stay reachable on Discord so we can move you into a match.",
    },
  ],
};

export const TOO_GOOD_TO_BE_TRUE = {
  eyebrow: "Trust",
  title: "Sounds too good to be true?",
  titleAccent: "true",
  body: "A new CS site asking for Steam login is a fair reason to be suspicious. That instinct is correct. People get scammed in this game constantly. Do not take our word for it. Join Discord and ask someone who has already played a match night.",
  teamTitle: "The team you are trusting",
  teamFacts: [
    "Ouro is built by a small team of engineers and competitive players. We have years of experience building software and playing CS.",
    "We are in the Discord. Ask us directly.",
  ],
  steamFactsTitle: "What Steam sign-in actually does here",
  steamFacts: [
    "A Steam account is all you need to join. Everything else builds your reputation.",
    "Read-only. We cannot trade, gift, or move anything in your inventory.",
    "You sign in on Valve's own OpenID page, not on a fake Steam lookalike.",
    "We never see your Steam password.",
    "We never ask for a Steam API key.",
    "We cannot access or trade your inventory.",
    "ID verification is optional. If you do it, it runs through didit.me and adds to your reputation. It is not required to sign up or play.",
  ],
};
